import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/site/Wordmark";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const field = "w-full border border-[#E5E5E5] bg-white px-4 py-3 text-charcoal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-restrained-blue";

  return (
    <div className="min-h-screen flex items-center justify-center bg-off-white px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10"><Wordmark /></div>
        <div className="bg-white border border-[#E5E5E5] p-8 md:p-10">
          <p className="overline text-restrained-blue mb-2">Administration</p>
          <h1 className="font-serif text-3xl text-deep-navy mb-8">Sign in</h1>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="overline text-charcoal/60 block mb-2" htmlFor="al-email">Email</label>
              <input id="al-email" data-testid="admin-email" type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <label className="overline text-charcoal/60 block mb-2" htmlFor="al-password">Password</label>
              <input id="al-password" data-testid="admin-password" type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <p data-testid="admin-login-error" className="text-destructive text-sm">{error}</p>}
            <button type="submit" data-testid="admin-login-submit" disabled={loading}
                    className="w-full inline-flex items-center justify-center gap-2 bg-deep-navy text-white px-6 py-3.5 text-sm hover:bg-restrained-blue transition-colors disabled:opacity-60">
              {loading && <Loader2 className="animate-spin" size={16} />} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
